import { useParams, useLocation } from "react-router-dom"; // ← add useLocation
import api from "../api/axios";
import { useState, useEffect, createContext } from "react";

export const ProfileContext = createContext(undefined);

export default function ProfileProvider({ children }) {
  const { id } = useParams();

  const location = useLocation();

  const [isProfileInfo, setIsProfileInfo] = useState([]);
  const [IsUserProfile, setIsUserProfile] = useState([]);
  const [isState, setIsState] = useState([]);
  const [isMyPost, setIsMyPost] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(null);

  // Fetch profile on mount

  useEffect(() => {
    const handleProfile = async () => {
      try {
        const response = await api.get("/user/me");
        setIsProfileInfo(response.data.user);
      } catch (error) {
        setIsError("Profile Fetch Error");
      } finally {
        setIsLoading(false);
      }
    };
    handleProfile();
  }, [location.pathname]);

  // Update profile function
  const updateProfile = async (updatedData) => {
    try {
      const response = await api.put("/user/update-profile", updatedData, {
        // headers: { "Content-Type": "multipart/form-data" },
      });
      setIsProfileInfo(response.data.user);
    } catch (error) {
      console.error("Update profile error:", error.response?.data || error);
      setIsError(error.response?.data?.message || "Profile update error");
    }
  };

  useEffect(() => {
    const MyPost = async () => {
      try {
        const response = await api.get("feeds/me");
        setIsMyPost(response.data);
      } catch (error) {
        setIsError("Profile Fetch Error");
      } finally {
        setIsLoading(false);
      }
    };
    MyPost();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await api.get("/auth/states");

        const formatted = response.data.state.data.map((item, i) => ({
          stateName: item.state.name,
          districts: item.districts?.[i]?.name?.districts || [],
        }));

        setIsState(formatted);
      } catch (error) {
        console.error("State fetch error", error);
        setIsError("State fetch error");
      }
    };
    fetchStates();
  }, []);

  return (
    <ProfileContext.Provider
      value={{
        isProfileInfo,
        isLoading,
        updateProfile,
        setIsProfileInfo,
        setIsError,
        isMyPost,
        isError,
        IsUserProfile,
        isState,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
}